import React, {Component} from 'react';
import faq1 from "../../../../../../assets/img/faq1.png";
import faq2 from "../../../../../../assets/img/faq2.png";
import faq3 from "../../../../../../assets/img/faq3.png";
import faq4 from "../../../../../../assets/img/faq4.png";
import faq5 from "../../../../../../assets/img/faq5.png";
import faq6 from "../../../../../../assets/img/faq6.png";
import faq7 from "../../../../../../assets/img/faq7.png";
import faq8 from "../../../../../../assets/img/faq8.png";
import {Link} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import '../FaqPages/YourOrder.css'
import FocusPageId from "../../FocusPageId";
import '../Beginners.css'


class YourOrderTopics extends React.Component {
    constructor(props) {
        super(props);

        this.focusPage = this.focusPage.bind(this);

    }

    focusPage = (elementId) => {
        FocusPageId.selectedId = {elementId}
    }

    componentDidMount() {
        window.scrollTo(0, 0)


    }

    render() {

        return (
            <div className="static-pages">
                <div className="background-div">
                    <h3 className="inline-block-element"><b>ご注文について</b></h3>
                    <div className="brElement"></div>
                    <div onClick={() => this.focusPage("a")}>
                        <Link to='/yourorder'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 会員でなくても注文できますか？</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={() => this.focusPage("b")}>
                        <Link to='/yourorder'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 土曜日・日曜日・祝日も営業していますか？</b>
                            </h4>

                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={() => this.focusPage("c")}>
                        <Link to='/yourorder'>
                            <h4><b className="reduce-font-size cart-row-text-color"> サービス全体の流れがわかりません。</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={() => this.focusPage("d")}>
                        <Link to='/yourorder'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 電話での注文はできますか？</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={() => this.focusPage("e")}>
                        <Link to='/yourorder'>
                            <h4><b className="reduce-font-size cart-row-text-color"> スマートフォンでの注文はできますか？</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={() => this.focusPage("f")}>
                        <Link to='/yourorder'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 注文内容を確認したいのですが。</b>
                            </h4>

                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={() => this.focusPage("g")}>
                        <Link to='/yourorder'>
                            <h4><b className="reduce-font-size cart-row-text-color">ガーバーデータ作成について教えて下さい。</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={() => this.focusPage("h")}>
                        <Link to='/yourorder'>
                            <h4><b className="reduce-font-size cart-row-text-color"> プリント基板製造サービスで1000枚以上のご注文は可能ですか？</b>
                            </h4>
                        </Link>

                    </div>
                    <div className="brElement"></div>
                    <div onClick={() => this.focusPage("i")}>
                        <Link to='/yourorder'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 見積書発行はしてもらえますか？</b>
                            </h4>
                        </Link>

                    </div>
                    <div className="brElement"></div>
                    <div onClick={() => this.focusPage("j")}>
                        <Link to='/yourorder'>
                            <h4><b className="reduce-font-size cart-row-text-color">
                                注文番号はどこで確認できますか？
                            </b>
                            </h4>
                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={() => this.focusPage("k")}>
                        <Link to='/yourorder'>
                            <h4><b className="reduce-font-size cart-row-text-color"> リピート注文はできますか？</b>
                            </h4>
                        </Link>

                    </div>

                    {/*<br/>*/}
                    {/*<div onClick={() => this.focusPage("l")}>*/}
                    {/*<Link to='/yourorder'>*/}
                    {/*<h4><b>*/}
                    {/*複数の基板を注文したいのですが、方法を教えて下さい。</b>*/}
                    {/*</h4>*/}
                    {/*</Link>*/}

                    {/*</div>*/}

                    <div className="brElement"></div>
                    <div onClick={() => this.focusPage("m")}>
                        <Link to='/yourorder'>
                            <h4><b className="reduce-font-size cart-row-text-color">
                                プリント基板をシート形状にて注文する方法を教えて下さい。</b>

                            </h4>
                        </Link>

                    </div>
                    <div className="brElement"></div>
                    <div onClick={() => this.focusPage("n")}>
                        <Link to='/yourorder'>
                            <h4><b className="reduce-font-size cart-row-text-color">
                                メタルマスクの注文方法を教えて下さい。
                            </b>
                            </h4>
                        </Link>

                    </div>

                    {/*<div className='col-md-10'></div>*/}
                    <div className='faq-link-float-right   col-12-custom'>
                        <Link to="/frequent">
                            <span className='font-size-20 reduce-font-size'>
                            戻る
                            </span>
                        </Link>
                    </div>
                </div>

            </div>
        );
    }
}

export default YourOrderTopics;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/YourOrderTopics.js